import { API_CONFIG } from './api';

const buildUrl = (base, path, query = {}) => {
  const url = new URL(path, `${base}/`);
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null) url.searchParams.set(key, String(value));
  });
  return url.toString();
};

export const appUrl = (path = '/', query) => {
  const base = process.env.REACT_APP_USE_BROWSER_APP_ORIGIN === 'true' &&
    typeof window !== 'undefined'
    ? window.location.origin
    : process.env.REACT_APP_APP_URL || process.env.REACT_APP_DEFAULT_APP_URL;
  return buildUrl(base, path, query);
};

export const marketingUrl = (path = '/', query) =>
  buildUrl(process.env.REACT_APP_MARKETING_URL, path, query);

export const referralUrl = (code) => appUrl('/sign-up', { ref: code });

export const apiDocsUrl = (path = '/api') => buildUrl(API_CONFIG.BACKEND_URL, path);
